import type { UUID } from "utils";

const BASE_URL = "/connect";

const PROVIDER_CONFIG_BASE_URL = `${BASE_URL}/provider-config`;

export const PAGE_URLS = {
  connect: BASE_URL,
  accountDetails: `${BASE_URL}/account/:accountId`,
  providerConfigList: PROVIDER_CONFIG_BASE_URL,
  accountCreate: `${BASE_URL}/account/create`,
  isxPayoutConfiguration: `${BASE_URL}/payout-configuration-isx`,
  providerConfigDetails: `${PROVIDER_CONFIG_BASE_URL}/:configId`,
  notificationsSettings: `${BASE_URL}/notifications-settings`,
  getLinkToAccountDetails: (accountId: UUID) =>
    `${BASE_URL}/account/${accountId}`,
  getLinkToProviderConfigDetails: (configId: UUID) =>
    `${PROVIDER_CONFIG_BASE_URL}/${configId}`,
  getLinkToCreateProviderConfig: (providerId: UUID) =>
    `${PROVIDER_CONFIG_BASE_URL}/create/${providerId}`,
  getLinkToEditProviderConfig: (configId: UUID) =>
    `${PROVIDER_CONFIG_BASE_URL}/${configId}/edit`,
};
